









































import Vue from 'vue'
import moment from 'moment'
import { keyBy, orderBy } from 'lodash'

import ProgressCircle from '@/components/ProgressCircle.vue'
import { CURRENT_CASE } from '@/components/Constants'
import iptProgressIndicator from './depression/ipt/ProgressIndicator.vue'
import Process from '@/components/workflow/Process.vue'
import { ProcessLog, RunningProcess, TaskLog } from '@/store/workflow/types'

export default Vue.extend({
  components: {
    Process,
    ProgressCircle,
    iptProgressIndicator,
  },
  computed: {
    diagnosis(): 'mde' | 'ptsd' | 'counseling' {
      return this.$store.getters.currentCase!.diagnosis || 'mde'
    },
    totalSteps(): number {
      switch (this.diagnosis) {
        case 'mde':
          return 8
        case 'ptsd':
          return 6
        default:
        case 'counseling':
          return 5
      }
    },
    currentTrial(): RunningProcess | undefined {
      return this.$store.getters['workflow/currentTrial']
    },
    treatmentsWithinTrial(): ProcessLog[] {
      return Object.values(this.$store.getters['workflow/processLog'] as ProcessLog[])
        .filter(
          p =>
            p.root_instance_id === this.currentTrial!.id &&
            p.business_key!.match(/(ipt|cbt|expo|cr|counseling)-treatment/)
        )
        .sort((a, b) => new Date(a.start_time).getTime() - new Date(b.start_time).getTime())
        .reverse()
    },
    treatmentHasStarted(): boolean {
      return this.treatmentsWithinTrial.length > 0
    },
    treatmentHasEnded(): boolean {
      return (
        this.treatmentsWithinTrial.filter(p => p.state !== 'ACTIVE' && p.state !== 'SUSPENDED')
          .length > 0
      )
    },
    completedSteps(): number {
      const currentTrial = this.currentTrial
      if (!currentTrial) {
        return 0
      }

      const treatmentsWithinTrial = this.treatmentsWithinTrial

      if (treatmentsWithinTrial.length === 0) {
        return 0
      }

      const treatment = treatmentsWithinTrial[0] // just one treatment
      //console.log('currentTreatment', treatment)

      if (treatment.business_key!.match(/(ipt|cbt)-treatment/)) {
        const completedLetters = (this.$store.getters[
          'workflow/completedProcesses'
        ] as ProcessLog[]).filter(
          p =>
            p.state === 'COMPLETED' &&
            p.root_instance_id === currentTrial.id &&
            p.business_key!.match(/patient-writes-p(\d+)/)
        )
        return completedLetters.length
      }

      if (treatment.business_key!.match(/(expo|cr|counseling)-treatment/)) {
        const doneTasksWithinTreatment = (this.$store.getters[
          'workflow/doneTasks'
        ] as TaskLog[]).filter(
          t =>
            t.process_instance_id === treatment.id &&
            t.end_time &&
            t.task_definition_key.match(/write-p(\d+).*/)
        )
        //console.log('doneTasks', doneTasksWithinTreatment)

        return doneTasksWithinTreatment.length
      }

      return 5
    },
    letters(): any[] {
      const letters: { published_at: string; sender_id: string }[] = this.$store.getters[
        'letters/storedObjects'
      ]

      const members = keyBy(this.$store.getters[CURRENT_CASE]!.members!.nodes || [], 'userId')

      return orderBy(letters, ['published_at', 'asc'])
        .filter(
          letter =>
            letter.published_at &&
            letter.sender_id === this.$store.getters.currentCase!.patient.userId
        )
        .map(letter => ({
          ...letter,
          published_at: moment(letter.published_at),
          by: members[letter.sender_id] || {},
          by_me: letter.sender_id === this.$store.getters.currentUserId,
        }))
    },
  },
})
